// Link behind the "Powered by Hümo" line. The UTM tags let the signup page record
// that the visitor came from a customer's widget (acquisitionService: utm_medium
// "referral" → channel "referral") and which site it was. Never put the websiteId
// here: the widget sends it as an API key.
export function poweredByUrl(content: string): string {
  const url = new URL('https://meethumo.com/');
  url.searchParams.set('utm_source', 'widget');
  url.searchParams.set('utm_medium', 'referral');
  url.searchParams.set('utm_campaign', 'powered_by');
  let host = '';
  try {
    host = window.location.hostname.replace(/^www\./, '');
  } catch {
    // no window (tests, SSR)
  }
  url.searchParams.set('utm_content', host ? `${content}:${host}` : content);
  return url.toString();
}
